// Definitions that are used in data-models and therefore can't be in base

export const uniqueIDPrefix = 'uid_';
let uniqueIDCounter = 10000;
export function UniqueID(): string {
    return `${uniqueIDPrefix}${uniqueIDCounter++}`;
}

export function Arrayify<T>(x?: T | T[]) {
    return x === undefined ? [] : Array.isArray(x) ? x : [x];
}

export function Throw(message?: string): never {
    throw Error(message);
}

export function Assert(condition: unknown, msg = "Assert failed"): asserts condition {
    if (!condition) throw new Error(msg);
}

export function AssertExhausted(condition: never) {
}

export enum DesignBlockMode {
    Sidebar = "Sidebar",
    DragPreview = "Drag",
    Preview = "Preview",
    Live = "Live"
}
